var _path, _g, _path2, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiCurrencyItem1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -25.2227,
    y: -9.59399,
    width: 130.229,
    height: 100.197
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_0_974_11210_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 30,
    d: "M6.51892 43.1213C4.20872 41.8202 4.19411 39.6847 6.48628 38.3516L35.5934 21.4229C37.8855 20.0898 41.6165 20.0639 43.9267 21.3651L73.2627 37.8878C75.5729 39.189 75.5875 41.3245 73.2954 42.6576L44.1883 59.5862C41.8961 60.9193 38.1651 60.9452 35.8549 59.6441L6.51892 43.1213Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -25.2227,
    y: -9.59399,
    width: 130.229,
    height: 100.197
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_1_974_11210_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8722 21.58L6.76514 38.5086C4.62579 39.7529 4.63942 41.746 6.79561 42.9604L36.1316 59.4831C38.2878 60.6976 41.77 60.6734 43.9094 59.4291L73.0165 42.5005C75.1559 41.2563 75.1422 39.2631 72.986 38.0487L43.65 21.526C41.4938 20.3116 38.0116 20.3357 35.8722 21.58ZM6.48628 38.3516C4.19411 39.6847 4.20872 41.8202 6.51892 43.1213L35.8549 59.6441C38.1651 60.9452 41.8961 60.9193 44.1883 59.5862L73.2954 42.6576C75.5875 41.3245 75.5729 39.189 73.2627 37.8878L43.9267 21.3651C41.6165 20.0639 37.8855 20.0898 35.5934 21.4229L6.48628 38.3516Z",
    fill: "url(#paint0_linear_974_11210)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8722 21.58L6.76514 38.5086C4.62579 39.7529 4.63942 41.746 6.79561 42.9604L36.1316 59.4831C38.2878 60.6976 41.77 60.6734 43.9094 59.4291L73.0165 42.5005C75.1559 41.2563 75.1422 39.2631 72.986 38.0487L43.65 21.526C41.4938 20.3116 38.0116 20.3357 35.8722 21.58ZM6.48628 38.3516C4.19411 39.6847 4.20872 41.8202 6.51892 43.1213L35.8549 59.6441C38.1651 60.9452 41.8961 60.9193 44.1883 59.5862L73.2954 42.6576C75.5875 41.3245 75.5729 39.189 73.2627 37.8878L43.9267 21.3651C41.6165 20.0639 37.8855 20.0898 35.5934 21.4229L6.48628 38.3516Z",
    fill: "url(#paint1_radial_974_11210)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -27.5586,
    y: -28.603,
    width: 135.117,
    height: 102.996
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_2_974_11210_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 30,
    d: "M4.18299 25.5288C1.87279 24.2277 1.85817 22.0921 4.15034 20.759L35.693 2.41391C37.9851 1.08079 41.7161 1.05487 44.0263 2.35603L75.817 20.2613C78.1272 21.5625 78.1418 23.698 75.8497 25.0311L44.307 43.3762C42.0149 44.7093 38.2839 44.7352 35.9737 43.4341L4.18299 25.5288Z",
    fill: "url(#paint2_linear_974_11210)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -27.5586,
    y: -28.603,
    width: 135.117,
    height: 102.996
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_3_974_11210_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8324 2.49244L4.28977 20.8376C2.07401 22.1262 2.08814 24.1906 4.32133 25.4483L36.1121 43.3536C38.3452 44.6114 41.9518 44.5864 44.1676 43.2977L75.7102 24.9526C77.926 23.6639 77.9119 21.5996 75.6787 20.3418L43.8879 2.43649C41.6548 1.17871 38.0482 1.20375 35.8324 2.49244ZM4.15034 20.759C1.85817 22.0921 1.87279 24.2277 4.18299 25.5288L35.9737 43.4341C38.2839 44.7352 42.0149 44.7093 44.307 43.3762L75.8497 25.0311C78.1418 23.698 78.1272 21.5625 75.817 20.2613L44.0263 2.35603C41.7161 1.05487 37.9851 1.08079 35.693 2.41391L4.15034 20.759Z",
    fill: "url(#paint3_linear_974_11210)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8324 2.49244L4.28977 20.8376C2.07401 22.1262 2.08814 24.1906 4.32133 25.4483L36.1121 43.3536C38.3452 44.6114 41.9518 44.5864 44.1676 43.2977L75.7102 24.9526C77.926 23.6639 77.9119 21.5996 75.6787 20.3418L43.8879 2.43649C41.6548 1.17871 38.0482 1.20375 35.8324 2.49244ZM4.15034 20.759C1.85817 22.0921 1.87279 24.2277 4.18299 25.5288L35.9737 43.4341C38.2839 44.7352 42.0149 44.7093 44.307 43.3762L75.8497 25.0311C78.1418 23.698 78.1272 21.5625 75.817 20.2613L44.0263 2.35603C41.7161 1.05487 37.9851 1.08079 35.693 2.41391L4.15034 20.759Z",
    fill: "url(#paint4_radial_974_11210)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6235 22.8094C33.6201 22.3127 34.3209 21.9052 35.1887 21.8991L44.6168 21.8337C45.4847 21.8276 46.1909 22.2254 46.1943 22.7221C46.1977 23.2189 45.497 23.6264 44.6291 23.6325L35.201 23.6979C34.3332 23.704 33.6269 23.3062 33.6235 22.8094Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8843 19.1682C40.7521 19.1622 41.4584 19.56 41.4618 20.0567L41.4987 25.4531C41.5021 25.9498 40.8014 26.3574 39.9336 26.3634C39.0657 26.3694 38.3594 25.9716 38.356 25.4749L38.3191 20.0785C38.3157 19.5818 39.0165 19.1742 39.8843 19.1682Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_974_11210_clip_path",
    transform: "translate(25.2227 9.59399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51892 43.1213C4.20872 41.8202 4.19411 39.6847 6.48628 38.3516L35.5934 21.4229C37.8855 20.0898 41.6165 20.0639 43.9267 21.3651L73.2627 37.8878C75.5729 39.189 75.5875 41.3245 73.2954 42.6576L44.1883 59.5862C41.8961 60.9193 38.1651 60.9452 35.8549 59.6441L6.51892 43.1213Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_974_11210_clip_path",
    transform: "translate(25.2227 9.59399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8722 21.58L6.76514 38.5086C4.62579 39.7529 4.63942 41.746 6.79561 42.9604L36.1316 59.4831C38.2878 60.6976 41.77 60.6734 43.9094 59.4291L73.0165 42.5005C75.1559 41.2563 75.1422 39.2631 72.986 38.0487L43.65 21.526C41.4938 20.3116 38.0116 20.3357 35.8722 21.58ZM6.48628 38.3516C4.19411 39.6847 4.20872 41.8202 6.51892 43.1213L35.8549 59.6441C38.1651 60.9452 41.8961 60.9193 44.1883 59.5862L73.2954 42.6576C75.5875 41.3245 75.5729 39.189 73.2627 37.8878L43.9267 21.3651C41.6165 20.0639 37.8855 20.0898 35.5934 21.4229L6.48628 38.3516Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_974_11210_clip_path",
    transform: "translate(27.5586 28.603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18299 25.5288C1.87279 24.2277 1.85817 22.0921 4.15034 20.759L35.693 2.41391C37.9851 1.08079 41.7161 1.05487 44.0263 2.35603L75.817 20.2613C78.1272 21.5625 78.1418 23.698 75.8497 25.0311L44.307 43.3762C42.0149 44.7093 38.2839 44.7352 35.9737 43.4341L4.18299 25.5288Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_974_11210_clip_path",
    transform: "translate(27.5586 28.603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8324 2.49244L4.28977 20.8376C2.07401 22.1262 2.08814 24.1906 4.32133 25.4483L36.1121 43.3536C38.3452 44.6114 41.9518 44.5864 44.1676 43.2977L75.7102 24.9526C77.926 23.6639 77.9119 21.5996 75.6787 20.3418L43.8879 2.43649C41.6548 1.17871 38.0482 1.20375 35.8324 2.49244ZM4.15034 20.759C1.85817 22.0921 1.87279 24.2277 4.18299 25.5288L35.9737 43.4341C38.2839 44.7352 42.0149 44.7093 44.307 43.3762L75.8497 25.0311C78.1418 23.698 78.1272 21.5625 75.817 20.2613L44.0263 2.35603C41.7161 1.05487 37.9851 1.08079 35.693 2.41391L4.15034 20.759Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_11210",
    x1: 6.37284,
    y1: 36.876,
    x2: 55.4496,
    y2: 13.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_974_11210",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.50587 -23.7134 71.3319 14.0473 44.3941 58.0534)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_974_11210",
    x1: 7.96861,
    y1: 22.7798,
    x2: 62.9128,
    y2: -8.21353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_974_11210",
    x1: 4.29974,
    y1: 19.0303,
    x2: 56.5718,
    y2: -5.39959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_974_11210",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.79924 -25.2573 75.9762 14.9619 44.7965 41.5865)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCurrencyItem1);
export default __webpack_public_path__ + "static/media/multi_currency_item1.75b26dc459d58f4e4c678775a8472f2e.svg";
export { ForwardRef as ReactComponent };